module.exports = __webpack_public_path__ + "f4caf72547a7b151d7b60d7796c1ab87.png";